import React from 'react';
import TextIconButton from '../basicComponents/TextIconButton';
import { useIcons, useIntelliTags } from '../../utils/hooks';
import FileButton from '../basicComponents/FileButton';
import { getText } from '../../utils/functions';

function Information({
	portal,
	data,
	colors,
	documents = [],
	labels,
	setRouting = () => { },
	translate,
}) {
	/* RelevantHeight controlling variables */

	/* Icon hook */
	const { MoreCircle } = useIcons(colors);

	/* Default values for the styles */
	const defaultStyleDIV = {
		backgroundColor: colors?.background,
		color: colors?.text,
		transition: 'all 100ms ease-in',
	};

	/* Intelligent tags to be swaped */
	const { applyIntelliTags } = useIntelliTags({ portal, translate });

	return (
		<div
			id='Information'
			className='relative pb-7 md:pb-24'
			style={defaultStyleDIV}
		>
			{/* INFORMATION - DESKTOP IN ROW DISPLAY - MOBILE IN COLUMN DISPLYA */}
			<div
				id='FlexInformation'
				className='flex max-w-screen-2xl md:mx-auto font-lato justify-center flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-16 '
			>
				{/* DESCRIPTIONS */}
				{data?.information?.isActive
					&& <div
						id='Descriptions'
						className={'text-xs md:text-base text-justify pt-5 md:pt-14 px-5'}
						dangerouslySetInnerHTML={{
							__html: applyIntelliTags(
								getText(data?.information, translate)
							)
						}}
					/>
				}

				{/* DOCUMENTS */}
				{documents.length > 0 && <div
					id='Documents'
					className={'flex flex-col space-y-8 px-5'}
				>
					{/* TITLE */}
					{data?.documentation?.isActive
						&& <label className='w-max md:pt-12 text-2xl md:text-2xl font-bold'>
							{getText(data?.documentation, translate)}
						</label>}
					{/* MOST IMPORTANT FILES */}
					{portal?.attachments[0].showInHome === true
						&& <div className={'flex flex-col text-xs md:text-base space-y-6'}>
							{documents.map(file => (
								<FileButton
									colors={colors}
									key={file.id}
									file={file}
									translate={translate}
									text={labels[file.id]} />
							))}
						</div>}
					{/* MORE DOCUMENTS */}
					{data?.moreDocumentation?.isActive
						&& portal?.attachments?.length > 3 && <TextIconButton
						text={getText(data?.moreDocumentation, translate)}
						Icon={MoreCircle}
						colors={colors}
						onClick={() => setRouting('documents')} />}
				</div>}
			</div>
		</div>
	);
}

export default Information;
